import React from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { Text as NBText } from 'native-base';
export function Text({ color, children, fontToken, fontWeight, fontFamily = 'body', fontSize = 16, letterSpacing = 0, lineHeight, ...rest }) {
    const getTokenOrDefault = () => {
        if (fontWeight) {
            return fontWeight;
        }
        return fontToken ? fontToken : 'normal';
    };
    return (React.createElement(NBText, { color: color, fontSize: fontToken ? fontToken : fontSize, letterSpacing: fontToken ? fontToken : letterSpacing, lineHeight: fontToken ? fontToken : lineHeight, fontWeight: getTokenOrDefault(), fontFamily: fontToken ? fontToken : fontFamily, ...rest }, children));
}
